import { Classroom } from '@/api/classroom'

const state = {
  materials: [],
  material: {},
  savedIdClassroomMaterial: 0,
  loadingMaterial: false,
  successMaterial: true,
  messageMaterial: '',
}

const getters = {
  materials: state => state.materials,
  material: state => state.material,
  savedIdClassroomMaterial: state => state.savedIdClassroomMaterial,
  loadingMaterial: state => state.loadingMaterial,
  successMaterial: state => state.successMaterial,
  messageMaterial: state => state.messageMaterial,
}

const actions = {
  async fetchAllMaterials({commit}, classCode) {
    commit('setLoadingMaterial', true)
    await Classroom.getAllMaterials(classCode)
    .then(res => {
      commit('setMaterials', res.data.data)
      commit('setLoadingMaterial', false)
    })
    .catch(err => {
      commit('setMessageMaterial', err.erros[0].message)
      commit('setLoadingMaterial', false)
    })
  },
  async createMaterial({commit}, data) {
    await Classroom.addMaterial(data.classCode, data.payload)
    .then(res => {
      if(res.data.success) {
        commit('setSuccessMaterial', true)
        commit('setMessageMaterial', 'Berhasil Menambahkan Materi')
      } else {
        commit('setSuccessMaterial', false)
        commit('setMessageMaterial', 'Terjadi Kesalahan')
      }
    })
    .catch(err => {
      commit('setSuccessMaterial', false)
      commit('setMessageMaterial', err.erros[0].message)
    })
  },
  async editMaterial({commit}, data) {
    await Classroom.updateMaterial(data.id, data.payload)
    .then(res => {
      if(res.data.success) {
        commit('setSuccessMaterial', true)
        commit('setMessageMaterial', 'Berhasil Mengubah Urutan Materi')
      } else {
        commit('setSuccessMaterial', false)
        commit('setMessageMaterial', 'Terjadi Kesalahan')
      }
    })
    .catch(err => {
      commit('setSuccessMaterial', false)
      commit('setMessageMaterial', err.errors[0].message)
    })
  },
  async removeMaterial({commit}, id) {
    await Classroom.deleteMaterial(id)
    .then(res => {
      if(res.data.success) {
        commit('setSuccessMaterial', true)
        commit('setMessageMaterial', 'Berhasil Menghapus Materi')
      } else {
        commit('setSuccessMaterial', false)
        commit('setMessageMaterial', 'Terjadi Kesalahan')
      }
    })
    .catch(err => {
      commit('setSuccessMaterial', false)
      commit('setMessageMaterial', err.errors[0].message)
    })
  },
  async createMaterialItem({commit}, data) {
    await Classroom.addMaterialItem(data.materialId, data.payload)
    .then(res => {
      if(res.data.success) {
        commit('setSuccessMaterial', true)
        commit('setMessageMaterial', 'Berhasil Menambahkan Sub-Materi')
      } else {
        commit('setSuccessMaterial', false)
        commit('setMessageMaterial', 'Terjadi Kesalahan')
      }
    })
    .catch(err => {
      commit('setSuccessMaterial', false)
      commit('setMessageMaterial', err.erros[0].message)
    })
  },
  async editMaterialItem({commit}, data) {
    await Classroom.updateMaterialItem(data.materialItemId, data.payload)
    .then(res => {
      if(res.data.success) {
        commit('setSuccessMaterial', true)
        commit('setMessageMaterial', 'Berhasil Mengubah Urutan Sub-Materi')
      } else {
        commit('setSuccessMaterial', false)
        commit('setMessageMaterial', 'Terjadi Kesalahan')
      }
    })
    .catch(err => {
      commit('setSuccessMaterial', false)
      commit('setMessageMaterial', err.errors[0].message)
    })
  },
  async removeMaterialItem({commit}, id) {
    await Classroom.deleteMaterialItem(id)
    .then(res => {
      if(res.data.success) {
        commit('setSuccessMaterial', true)
        commit('setMessageMaterial', 'Berhasil Menghapus Sub-Materi')
      } else {
        commit('setSuccessMaterial', false)
        commit('setMessageMaterial', 'Terjadi Kesalahan')
      }
    })
    .catch(err => {
      commit('setSuccessMaterial', false)
      commit('setMessageMaterial', err.errors[0].message)
    })
  },
}

const mutations = {
  setMaterials: (state, materials) => {
    state.materials = materials
  },
  setMaterial: (state, material) => {
    state.material = material
  },
  setSavedIdClassroomMaterial: (state, id) => {
    state.savedIdClassroomMaterial = id
  },
  setLoadingMaterial: (state, loading) => {
    state.loadingMaterial = loading
  },
  setSuccessMaterial: (state, success) => {
    state.successMaterial = success
  },
  setMessageMaterial: (state, message) => {
    state.messageMaterial = message
  },
}

export default {
  state,
  getters,
  actions,
  mutations,
}